import type { FC } from 'react';

export interface PlanDetailsFooterProps {
    loadedCount: number;
    totalCount: number;
    createdBy: string | undefined;
}

const PlanDetailsFooter: FC<PlanDetailsFooterProps> = ({ loadedCount, totalCount, createdBy }) => (
    <div className="fixed bottom-14 z-10 left-0 right-0 flex rounded-b-lg border-t border-[#bfbfbf] text-xs text-[#52525c] items-center gap-x-6 bg-[#E4E4E7] mx-4">
        <div className="flex-1 flex items-center h-8 px-[15px]">
            <p>{`Showing ${loadedCount.toLocaleString()} of ${totalCount.toLocaleString()} Records`}</p>
        </div>
        <div className="flex items-center h-8 px-[15px]">
            <p>{`Created by: ${createdBy ?? ''}`}</p>
        </div>
    </div>
);

PlanDetailsFooter.displayName = 'PlanDetailsFooter';
export default PlanDetailsFooter;
